<template>
  <div class="ag-label" :data-disabled="disabled">
    <div v-if="$slots.prepend" class="ag-label__prepend">
      <slot name="prepend" />
    </div>

    <div class="ag-label__container">
      <AGTruncatedText class="ag-label__label" :class="[fontWeightClass, fontSizeClass]">{{ label }}</AGTruncatedText>

      <div class="ag-label__value-container">
        <v-progress-linear v-if="loading" color="#ECE7F5" height="38px" class="mb-2 rounded" indeterminate />

        <div v-else class="ag-label__value">
          <slot />
        </div>
      </div>
    </div>

    <div v-if="$slots.append" class="ag-label__append">
      <slot name="append" />
    </div>
  </div>
</template>

<script>
import AGTruncatedText from '@/components/common/AGTruncatedText.vue';

export default {
  components: { AGTruncatedText },
  props: {
    label: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fontWeight: {
      type: String,
      default: 'regular',
      validator: (value) => ['regular', 'bold'].includes(value),
    },
    fontSize: {
      type: String,
      default: 'xxxs',
      validator: (value) => ['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl'].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fontWeightClass() {
      return `ag-label__label--${this.fontWeight}`;
    },
    fontSizeClass() {
      return `ag-label__label--${this.fontSize}`;
    },
  },
};
</script>

<style scoped lang="scss">
.ag-label {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  padding: 4px 0;
  border-radius: 4px;

  &__container {
    width: fit-content;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  &[data-disabled='true'] {
    background-color: $neutral-color-low-dark;
    padding: 4px 16px;
    color: $neutral-color-high-medium;
  }
}

.ag-label__label {
  line-height: $line-height-md;
  color: $neutral-color-high-medium;

  &--regular {
    font-weight: $font-weight-regular;
  }

  &--bold {
    font-weight: $font-weight-bold;
  }

  &--xxxs {
    font-size: $font-size-xxxs;
  }

  &--xxs {
    font-size: $font-size-xxs;
  }

  &--xs {
    font-size: $font-size-xs;
  }

  &--sm {
    font-size: $font-size-sm;
  }

  &--md {
    font-size: $font-size-md;
  }

  &--lg {
    font-size: $font-size-lg;
  }

  &--xl {
    font-size: $font-size-xl;
  }
}
</style>
